
<div>
  <div
    class="taskcard"
    :class="{
      'info-red-border': item.priority == boardItemPriority.High,
      'taskcard-error-border': itemHasError(item),
    }"
    @click="navigate(item)"
  >
    <div class="taskcard-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <i class="far fa-fw p-1 mr-2" :class="item.categoryIcon"></i>
          {{ item.categoryName }}
        </div>

        <div v-if="displayStatus || isSO" class="board-item-status-right mr-2">
          <div
            class="badge badge-pill"
            :class="{
              'badge-primary': item.boardItemStatus === boardItemStatus.Planned,
              'badge-info': item.boardItemStatus === boardItemStatus.Information,
              'badge-warning': item.boardItemStatus === boardItemStatus.InProgress,
              'badge-success': item.boardItemStatus == boardItemStatus.Done || item.boardItemStatus == boardItemStatus.UnderReview,
            }"
          >
            {{ boardItemStatusDisplayName }}
          </div>
        </div>

        <div v-if="item.listId !== boardItemListType.Done" class="d-flex align-items-center">
          <BoardItemPlannedDate :item="item" class="mr-2" />
          <DueBadge :item="item"></DueBadge>
        </div>

        <div v-if="item.isMoved && !item.isDelegated" class="badge badge-secondary badge-pill">
          <i class="fas fa-share"></i>
          <span class="ml-1">{{ initialBoardName }}</span>
        </div>
        <div v-if="item.isDelegated && item.ownerBoardId !== boardStore.currentBoardId" class="badge badge-secondary badge-pill">
          <i class="fas fa-repeat"></i>
          <span class="ml-1">{{ initialBoardName }}</span>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <div class="ml-1 font-weight-normal d-flex align-items-center">
          <i class="fa-fw far fa-angle-double-right p-1 mr-1"></i>
          {{ item.typeName }}
        </div>

        <div v-if="item.isRelevantForReport" class="badge badge-dark badge-pill p-1 mr-1 px-2">Report Relevant</div>
        <div v-if="item.isConfidential" class="badge badge-warning badge-pill p-1 mr-1 px-2">Confidential</div>
      </div>
    </div>

    <div class="taskcard-content">
      <div class="d-flex align-items-center justify-content-between">
        <div class="ml-2">
          <BoardItemLabels :item="item" :isSelectable="true" />

          <div class="title">{{ item.title }}</div>
          <div class="text-secondary description" v-if="!minimal">{{ item.description | stripHtml }}</div>
        </div>

        <div v-if="itemHasError(item)" class="taskcard-error-indicator">
          <i class="far fa-exclamation-triangle"></i>
        </div>

        <div class="align-self-start flex-1 d-flex align-items-center" v-if="!minimal">
          <div class="info-box mr-2 info-box-orange" v-if="showNotification(item)">
            <div class="info-item">
              <i class="fa fa-info fa-i" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div
          class="align-self-start flex-1 d-flex align-items-center cursor-pointer"
          v-if="item.assignedToUserShortName && !minimal"
          @click.stop="selectUser($event)"
        >
          <div class="avatar">{{ item.assignedToUserShortName.substr(0, 3) }}</div>
        </div>
      </div>

      <div class="d-flex justify-content-between mt-1" v-if="!minimal">
        <div class="pl-2 d-flex">
          <div class="text-secondary" v-if="item.commentCount > 0">
            <i class="far fa-comment"></i>
            {{ item.commentCount }}
          </div>
        </div>

        <div>
          <div class="text-secondary" v-if="displayChecklistProgress">
            <i class="fas fa-tasks"></i>
            {{ closedChecklistsCount }}
          </div>
        </div>

        <div>
          <div class="text-secondary" v-if="item.attachmentCount > 0">
            <i class="far fa-file"></i>
            {{ item.attachmentCount }}
          </div>
        </div>
      </div>

      <div v-if="item.specialOccurrenceId && !isSO">
        <hr class="mb-1" />
        <div class="d-flex justify-content-center">
          <div class="badge badge-pill" :class="getOccurrenceClass(item)">
            {{ item.specialOccurrenceName || 'Occurrence' }}
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-between validtimes flex-col"
        v-if="item.listName === listGroupType.Information"
      >
        <div class="flex-start" v-if="item.validFromDate">From: {{ item.validFromDate | formatDateTime }}</div>
        <div class="ml-auto" v-if="item.validToDate">To: {{ item.validToDate | formatDateTime }}</div>
      </div>

      <template v-if="sharedBoards.length">
        <hr class="mb-1" />
        <div class="mt-2">
          <div
            class="badge badge-pill p-1 mr-1 mb-1 px-2"
            :class="getSharedBadgeColor(board)"
            :title="getSharedBadgeTooltip(board)"
            v-b-tooltip:hover
            v-for="board in sharedBoards"
            :key="board.boardId"
          >
            {{ board.title }}
          </div>
        </div>
      </template>

      <BoardItemAcceptReject :item="item" :list="list" :view="acceptRejectView.Horizontal"></BoardItemAcceptReject>
    </div>
  </div>
</div>
